import axios from "axios";
import {Result, URLSearchParamsBuilder} from "@zhoujianhui/vip-core";

const leaveWordService = {
    baseUrl: "/leave-words",

    /**
     * 发布留言
     * @param leaveWordSaveDto
     */
    async releaseLeaveWord(leaveWordSaveDto) {
        try {
            await axios.post(this.baseUrl, leaveWordSaveDto);
            return Result.success("发布留言成功！").build();
        } catch (error) {
            return Result.error("发布留言失败！" + error.message).build();
        }
    },

    /**
     * 上传留言板附件至服务器
     * @param params
     */
    async uploadImage(params) {
        try {
            const response = await axios.post('/file-storages/attachment', params, {headers: {'Content-Type': 'multipart/form-data'}});
            return Result.success("上传成功！").data(response.data).build();
        } catch (error) {
            return Result.error("上传失败！").build();
        }
    },

    /**
     * 查询留言列表
     * @param leaveWordQuery 查询参数
     * @param pageable 分页参数
     */
    async searchLeaveWords(leaveWordQuery, pageable) {
        const params = new URLSearchParamsBuilder()
            .appendObject(leaveWordQuery)
            .appendPageable(pageable)
            .build()
        try {
            const response = await axios.get(this.baseUrl, {params: params});
            return Result.success("查询成功").data(response.data).build();
        } catch (error) {
            return Result.error("查询失败！").build();
        }
    },

    async findLeaveWordDetailById(id) {
        try {
            const response = await axios.get(`${this.baseUrl}/${id}`);
            return Result.success("查询留言详情成功").data(response.data).build();
        } catch (error) {
            return Result.error("查询留言详情失败！" + error.message).build();
        }
    },

    async findMyLeaveWordList(pageable) {
        const params = new URLSearchParamsBuilder()
            .appendPageable(pageable)
            .build()
        try {
            const response = await axios.get(`${this.baseUrl}/mine`, {params: params});
            return Result.success("查询成功").data(response.data).build();
        } catch (error) {
            return Result.error("查询失败！" + error.message).build();
        }
    },

    async findMyLeaveWordDetail(id) {
        try {
            const response = await axios.get(`${this.baseUrl}/${id}/mine`);
            return Result.success("查询成功").data(response.data).build();
        } catch (error) {
            return Result.error("查询失败！" + error.message).build();
        }
    }
}
export default leaveWordService;